import {getFunctions,httpsCallable} from 'firebase/functions';
export async function crmWorkspace(businessId,action,payload={}) {
 const result=await httpsCallable(getFunctions(),'crmWorkspaceV2')({businessId,action,...payload});return result.data;
}
export async function readPrivateCrmFile(businessId,customerId,fileId) {
 const result=await crmWorkspace(businessId,'fileRead',{customerId,fileId});
 const bytes=Uint8Array.from(atob(result.base64),c=>c.charCodeAt(0));
 const url=URL.createObjectURL(new Blob([bytes],{type:result.contentType}));
 const anchor=document.createElement('a');anchor.href=url;anchor.download=result.name;anchor.click();setTimeout(()=>URL.revokeObjectURL(url),60000);
}
export async function uploadPrivateCrmFile(businessId,customerId,file) {
 if(file.size>5*1024*1024||!['application/pdf','image/jpeg','image/png'].includes(file.type))throw Error('Selecciona un PDF, JPG o PNG de hasta 5 MB.');
 const base64=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(String(reader.result).split(',')[1]);reader.onerror=reject;reader.readAsDataURL(file);});
 return crmWorkspace(businessId,'fileUpload',{customerId,name:file.name,contentType:file.type,base64});
}
